import { useCallback, useState } from "react";
import { BaseFiltroPaginate } from "resources/enums/paginate";
import { FiltroAcordos } from "core/features/acordo/typings";

function useFiltroAcordos() {
  const [filtro, setFiltro] = useState<FiltroAcordos>({
    page: 1,
    limit: BaseFiltroPaginate.Limit,
    search: "",
    status: undefined,
  });

  const onChangeFiltro = useCallback((_filtro: Partial<FiltroAcordos>) => {
    setFiltro((state) => ({ ...state, ..._filtro }));
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
  };
}

export default useFiltroAcordos;
